<div class="rich-text-section {{editorClasses}}" (mouseover)="hoverOver(true)" (mouseout)="hoverOver(false)">

  <quill-editor *ngIf="!readOnly && text != null" class="rich-text-section-editor {{editorClasses}}" [(ngModel)]="text"
    [format]="format" [readOnly]="false" [customOptions]="quillOptions" [modules]="quillModules" #quillEditor>
  </quill-editor>
  <quill-editor *ngIf="readOnly && text != null && format != 'html'" class="rich-text-section-editor {{editorClasses}}"
    [ngModel]="textTransformed" [format]="format" [readOnly]="true" [customOptions]="quillOptions"
    [modules]="quillModules" #quillEditor>
  </quill-editor>
  <div *ngIf="readOnly && text != null && format == 'html'" class="rich-text-section-editor {{editorClasses}}"
    [innerHtml]="textTransformed | safeHtml"></div>

  <div class="rich-text-section-controls" [@crossfade]="controlsEnabled ? 'show' : 'hide'">
    <button *ngIf="editAvailable" [disabled]="!editToggleEnabled" mat-raised-button
      class="edit-toggle action-button action-button-small" (click)="readOnly = !readOnly">
      <mat-icon>edit</mat-icon>
    </button>

    <ng-container *ngFor="let action of actions">
      <button *ngIf="action.doAction && action.available" mat-raised-button class="action-button action-button-small"
        (click)="action.doAction()" disabled="{{!action.enabled}}">
        <mat-icon *ngIf="action.icon">{{action.icon}}</mat-icon><span *ngIf="action.title">{{action.title}}</span>
      </button>
    </ng-container>
  </div>
</div>
